"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerTypes = exports.offerTypeCodes = exports.lineItemFlowCodes = exports.panelViewDetails = exports.panelNames = exports.WIRELESS_NEW_AL_FLOWCODES = exports.WIRELESS_NEW_AL_UP_FLOWCODES = exports.DIGITAL_LOB_LIST = exports.WIRELESS_LOB_LIST = exports.HISA_LOB_LIST = exports.bundleFlowCodes = exports.VoiceLineFormType = exports.FlowType = exports.CheckoutPageLoadErrors = exports.CheckoutErrorCodes = exports.PANEL_STATUS = exports.LOBNames = void 0;
var icons = require("../styles/ccc-icons.scss");
var LOBNames;
(function (LOBNames) {
    LOBNames["LOB_WIRELESS"] = "WIRELESS";
    LOBNames["LOB_DTVS"] = "DTVS";
    LOBNames["LOB_PREPAID"] = "PREPAID";
    LOBNames["LOB_DTV_NOW"] = "DTVNOW";
    LOBNames["LOB_BROADBAND"] = "BROADBAND";
    LOBNames["LOB_IPTV"] = "IPTV";
    LOBNames["LOB_ACCESSORY"] = "ACCESSORY";
    LOBNames["LOB_HBOMAX"] = "HBOMAX";
    LOBNames["LOB_BUSINESSAPPS"] = "BUSINESSAPPS";
})(LOBNames = exports.LOBNames || (exports.LOBNames = {}));
var PANEL_STATUS;
(function (PANEL_STATUS) {
    PANEL_STATUS["REQUEST_INITIATED"] = "REQUEST_INITIATED";
    PANEL_STATUS["RESPONSE_RECEIVED"] = "RESPONSE_RECEIVED";
    PANEL_STATUS["NO_STATUS"] = "NO_STATUS";
})(PANEL_STATUS = exports.PANEL_STATUS || (exports.PANEL_STATUS = {}));
var CheckoutErrorCodes;
(function (CheckoutErrorCodes) {
    CheckoutErrorCodes["SERVICE_1000"] = "service-i-1000";
    CheckoutErrorCodes["SERVICE_1001"] = "service-i-1001";
})(CheckoutErrorCodes = exports.CheckoutErrorCodes || (exports.CheckoutErrorCodes = {}));
var CheckoutPageLoadErrors;
(function (CheckoutPageLoadErrors) {
    CheckoutPageLoadErrors["ACCOUNT_DETAILS_MISSING"] = "CHECKOUT_PAGE_USER_ACCOUNT_DETAILS_MISSING";
    CheckoutPageLoadErrors["EMPTY_RESPONSE"] = "CHECKOUT_PAGE_LOAD_EMPTY_RESPONSE";
    CheckoutPageLoadErrors["ADDRESS_OBJ_MISSING"] = "CHECKOUT_PAGE_LOAD_ADDRESS_OBJ_MISSING";
    CheckoutPageLoadErrors["PERSONALINFO_OBJ_MISSING"] = "CHECKOUT_PAGE_LOAD_PERSONALINFO_OBJ_MISSING";
    CheckoutPageLoadErrors["PAYMENT_OBJ_MISSING"] = "CHECKOUT_PAGE_LOAD_PAYMENT_OBJ_MISSING";
    CheckoutPageLoadErrors["TERMS_OBJ_MISSING"] = "CHECKOUT_PAGE_LOAD_TERMS_OBJ_MISSING";
    CheckoutPageLoadErrors["UNKNOWN_FAILURE"] = "CHECKOUT_PAGE_LOAD_UNKNOWN_FAILURE";
    CheckoutPageLoadErrors["TIMOUT_OR_API_FAILURE"] = "CHECKOUT_PAGE_LOAD_TIMOUT_OR_API_FAILURE";
    CheckoutPageLoadErrors["SHIPPING_INFO_MISSING"] = "CHECKOUT_PAGE_LOAD_SHIPPING_INFO_MISSING";
    CheckoutPageLoadErrors["LOGINPROFILE_EMPINFO_CTO_RESPONSE"] = "CHECKOUT_PAGE_LOAD_LOGINPROFILE_EMPINFO_CTO_RESPONSE";
    CheckoutPageLoadErrors["PERSONALINFO_EMPINFO_MISSING"] = "CHECKOUT_PAGE_LOAD_PERSONALINFO_EMPINFO_MISSING";
    CheckoutPageLoadErrors["PAYMENT_TERMS_OBJ_MISSING"] = "CHECKOUT_PAGE_LOAD_PAYMENT_TERMS_OBJ_MISSING";
    CheckoutPageLoadErrors["BSSE_AAL_BILLING_ADDRESS_NOT_EXACT_MATCH"] = "BSSE_AAL_BILLING_ADDRESS_NOT_EXACT_MATCH";
})(CheckoutPageLoadErrors = exports.CheckoutPageLoadErrors || (exports.CheckoutPageLoadErrors = {}));
var FlowType;
(function (FlowType) {
    FlowType["NEW_WIRELESS"] = "NEW_WIRELESS";
    FlowType["NEW_DTVS"] = "NEW_DTVS";
    FlowType["NEW_BROADBAND"] = "NEW_BROADBAND";
    FlowType["NEW_DTV_NOW"] = "NEW_DTVNOW";
    FlowType["CRP"] = "CRP";
    FlowType["NEW_DTV_NOW_CRP"] = "NEW_DTV_NOW_CRP";
    FlowType["NEW_DTVNOW_EXISTING_WIRELESS"] = "NEW_DTVNOW_EXISTING_WIRELESS";
    FlowType["UNKNOWN"] = "UNKNOWN";
    FlowType["WIRELESS_PREPAID"] = "PREPAID";
    FlowType["NEW_DTVNOW_NEW_WIRELESS"] = "NEW_DTVNOW_NEW_WIRELESS";
    FlowType["NEW_DTVNOW_EXISTING_WIRELESS_CRP"] = "NEW_DTVNOW_EXISTING_WIRELESS_CRP";
    FlowType["NEW_IPTV"] = "NEW_IPTV";
    FlowType["NEW_DTVS_ACCESSORY"] = "NEW_DTVS_NEW_ACCESSORY";
    FlowType["NEW_DTVNOW_NEW_BROADBAND"] = "NEW_DTVNOW_NEW_BROADBAND";
    FlowType["UPGRADE_WIRELESS"] = "UPGRADE_WIRELESS";
    FlowType["UP_AL_WIRELESS"] = "UP_AL_WIRELESS";
    FlowType["AAL_WIRELESS"] = "AAL_WIRELESS";
    FlowType["NEW_IPTV_NEW_BROADBAND"] = "NEW_IPTV_NEW_BROADBAND";
    FlowType["NEW_DTVS_NEW_BROADBAND"] = "NEW_DTVS_NEW_BROADBAND";
    FlowType["NEW_DTVNOW_EXISTING_BROADBAND"] = "NEW_DTVNOW_EXISTING_BROADBAND";
    FlowType["EXISTING_DTVNOW_NEW_BROADBAND"] = "EXISTING_DTVNOW_NEW_BROADBAND";
    FlowType["EXISTING_BROADBAND_NEW_DTVNOW"] = "EXISTING_BROADBAND_NEW_DTVNOW";
    FlowType["NEW_BROADBAND_NEW_HBOMAX"] = "NEW_BROADBAND_NEW_HBOMAX";
    FlowType["EXISTING_DTVNOW_NEW_BROADBAND_NEW_HBOMAX"] = "EXISTING_DTVNOW_NEW_BROADBAND_NEW_HBOMAX";
    FlowType["NEW_DTVNOW_NEW_BROADBAND_NEW_HBOMAX"] = "NEW_DTVNOW_NEW_BROADBAND_NEW_HBOMAX";
    FlowType["NEW_WIRELESS_NEW_HBOMAX"] = "NEW_WIRELESS_NEW_HBOMAX";
    FlowType["NEW_WIRELESS_ON_ACTIVATION_NEW_HBOMAX"] = "NEW_WIRELESS_ON_ACTIVATION_NEW_HBOMAX";
    FlowType["NEW_DTVS_NEW_BROADBAND_NEW_HBOMAX"] = "NEW_DTVS_NEW_BROADBAND_NEW_HBOMAX";
    FlowType["NEW_WIRELESS_ACTIVATION"] = "NEW_WIRELESS_ACTIVATION";
    FlowType["NEW_WIRELESS_ACTIVATION_NEW_HBOMAX"] = "NEW_WIRELESS_ACTIVATION_NEW_HBOMAX";
    FlowType["AAL_WIRELESS_NEW_HBOMAX"] = "AAL_WIRELESS_NEW_HBOMAX";
    FlowType["AAL_WIRELESS_ACTIVATION"] = "AAL_WIRELESS_ACTIVATION";
    FlowType["AAL_WIRELESS_ON_ACTIVATION"] = "AAL_WIRELESS_ON_ACTIVATION";
    FlowType["AAL_WIRELESS_ACTIVATION_NEW_HBOMAX"] = "AAL_WIRELESS_ACTIVATION_NEW_HBOMAX";
    FlowType["NEW_BROADBAND_NEW_BUSINESSAPPS"] = "NEW_BROADBAND_NEW_BUSINESSAPPS";
    FlowType["NEW_BUSINESSAPPS"] = "NEW_BUSINESSAPPS";
    FlowType["NEW_BROADBAND_NEW_VOIP"] = "NEW_BROADBAND_NEW_VOIP";
})(FlowType = exports.FlowType || (exports.FlowType = {}));
var VoiceLineFormType;
(function (VoiceLineFormType) {
    VoiceLineFormType["KEEP_NUMBER"] = "Keep my number";
    VoiceLineFormType["NEW_NUMBER"] = "Get a new number";
})(VoiceLineFormType = exports.VoiceLineFormType || (exports.VoiceLineFormType = {}));
exports.bundleFlowCodes = "|" + FlowType.NEW_DTVNOW_NEW_BROADBAND + "|";
exports.HISA_LOB_LIST = "|" + LOBNames.LOB_DTVS + "|" + LOBNames.LOB_BROADBAND + "|" + LOBNames.LOB_IPTV + "|";
exports.WIRELESS_LOB_LIST = "|" + LOBNames.LOB_WIRELESS + "|" + LOBNames.LOB_PREPAID + "|" + LOBNames.LOB_ACCESSORY + "|";
exports.DIGITAL_LOB_LIST = "|" + LOBNames.LOB_DTV_NOW + "|";
exports.WIRELESS_NEW_AL_UP_FLOWCODES = "|" + FlowType.NEW_WIRELESS + "|" + FlowType.NEW_WIRELESS_NEW_HBOMAX + "|\n  " + FlowType.AAL_WIRELESS + "|" + FlowType.AAL_WIRELESS_NEW_HBOMAX + "|" + FlowType.UPGRADE_WIRELESS + "|\n  " + FlowType.UP_AL_WIRELESS + "|";
exports.WIRELESS_NEW_AL_FLOWCODES = "|" + FlowType.NEW_WIRELESS + "|" + FlowType.NEW_WIRELESS_NEW_HBOMAX + "|\n  " + FlowType.AAL_WIRELESS + "|" + FlowType.AAL_WIRELESS_NEW_HBOMAX + "|";
var panelNames;
(function (panelNames) {
    panelNames["APPLE_DEBUG_PANEL"] = "appledebugpanel";
    panelNames["INSTALMENT_BILLING"] = "installmentbilling";
    panelNames["ACCOUNT_INFO"] = "accountinfo";
    panelNames["DELIVERY_INFO"] = "deliveryinfo";
    panelNames["NUMBER_SELECTION"] = "numberselections";
    panelNames["CREDIT_VERIFICATION"] = "creditVerification";
    panelNames["ACCESS_ID_INFO"] = "accessID";
    panelNames["ACCOUNT_SECURITY"] = "accountSecurity";
    panelNames["SCHEDULE_INSTALL"] = "scheduleInstall";
    panelNames["TERMS_AND_CONDITIONS"] = "terms";
    panelNames["PAYMENT_DETAILS"] = "payment";
    panelNames["BILL_PREFERENCE"] = "billPreferences";
    panelNames["DEVICE_TRADE_IN"] = "deviceTradeIn";
    panelNames["DONATION_OPTIONS"] = "donation";
    panelNames["VOICE_PANEL"] = "voicePanel";
    panelNames["BILL_ESTIMATOR"] = "billEstimator";
})(panelNames = exports.panelNames || (exports.panelNames = {}));
exports.panelViewDetails = {
    accessID: {
        icon: icons.cccIconPersonalsecurityL,
        iconStyle: true,
        name: 'Account access',
    },
    accountSecurity: {
        icon: icons.cccIconPersonalsecurityL,
        iconStyle: true,
        name: 'Account security',
    },
    accountinfo: {
        icon: icons.cccIconYoucontactL,
        iconStyle: true,
        name: 'Account info',
    },
    appledebugpanel: {
        icon: icons.cccIconApple,
        iconStyle: true,
        name: 'Debug Panel',
    },
    billEstimator: {
        icon: icons.cccIconBillEstimatorL,
        iconStyle: true,
        name: 'Bill estimates',
    },
    billPreferences: {
        icon: icons.cccIconBillingL,
        iconStyle: true,
        name: 'Bill preferences',
    },
    creditVerification: {
        icon: icons.cccIconSecureL,
        iconStyle: true,
        name: 'Credit review',
    },
    deliveryinfo: {
        icon: icons.cccIconShippingL,
        iconStyle: false,
        name: 'Delivery info',
    },
    deviceTradeIn: {
        icon: icons.cccIconRefurbisheddeviceL,
        iconStyle: false,
        name: 'Early upgrade terms',
    },
    donation: {
        icon: icons.cccIconApprovalL,
        iconStyle: true,
        name: 'Donations',
    },
    installmentbilling: {
        icon: icons.cccIconInstallbill,
        iconStyle: false,
        name: 'Installment billing',
    },
    numberselections: {
        icon: icons.cccIconInformationtransferL,
        iconStyle: true,
        name: 'Mobile number',
    },
    payment: {
        icon: icons.cccIconPayL,
        iconStyle: false,
        name: 'Payment',
    },
    scheduleInstall: {
        icon: icons.cccIconDatetimeL,
        iconStyle: true,
        name: 'Installation',
    },
    terms: {
        icon: icons.cccIconApprovalL,
        iconStyle: true,
        name: 'Terms',
    },
    voicePanel: {
        icon: icons.cccIconDatetimeL,
        iconStyle: true,
        name: 'Voice',
    },
};
var lineItemFlowCodes;
(function (lineItemFlowCodes) {
    lineItemFlowCodes["WIRELESS_AAL"] = "DSAAL";
    lineItemFlowCodes["WIRELESS_NEW"] = "DSNEW";
    lineItemFlowCodes["WIRELESS_UPGRADE"] = "DSUP";
    lineItemFlowCodes["WIRELESS_PREPAID"] = "DSPREPAID";
    lineItemFlowCodes["WIRELINE_DTVNOW"] = "DSDTVN";
    lineItemFlowCodes["WIRELINE_COMMON"] = "DSPRO";
    lineItemFlowCodes["WIRELINE_IPTVMIGRATION"] = "DSMIG";
    lineItemFlowCodes["EAP_NEW"] = "EANEW";
    lineItemFlowCodes["EAP_AAL"] = "EAAL";
    lineItemFlowCodes["UNKNOWN"] = "DSUNK";
    lineItemFlowCodes["ACCESSORY"] = "DSACC";
})(lineItemFlowCodes = exports.lineItemFlowCodes || (exports.lineItemFlowCodes = {}));
var offerTypeCodes;
(function (offerTypeCodes) {
    offerTypeCodes["RECONNECT"] = "reconnect";
    offerTypeCodes["ACQUISITION"] = "acquisition";
})(offerTypeCodes = exports.offerTypeCodes || (exports.offerTypeCodes = {}));
var CustomerTypes;
(function (CustomerTypes) {
    CustomerTypes["CONSUMER"] = "CONSUMER";
    CustomerTypes["SMB"] = "CRU";
    CustomerTypes["IRU"] = "IRU";
})(CustomerTypes = exports.CustomerTypes || (exports.CustomerTypes = {}));
//# sourceMappingURL=CheckoutConstants.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/utils/CheckoutConstants.js
// module id = 177
// module chunks = 8